import React, { ReactElement, useState } from "react";
import { CustomModal } from "../CustomModal";
import { useTranslate } from "@obsbot/remo-i18n";
import { Checkbox } from "antd";
import { withMessage } from "../../HOC/withMessage";
import "./index.less";

export interface DeregisterProps {
    visible: boolean;
    setVisible: (flag: boolean) => void;
    onConfirm: () => void;
}

const DEREGISTER_POLICY = "https://www.obsbot.com/account-deletion-policy";

export const DeregisterModal: React.FC<DeregisterProps> = withMessage(
    ({ visible, setVisible, message, onConfirm }): ReactElement => {
        const t = useTranslate();
        // 是否阅读须知
        const [isRead, setIsRead] = useState(false);
        const handleOnNext = (): void => {
            if (!isRead) {
                message.warning(t("deregisterAccount.dontRead"));
                return;
            }
            onConfirm && onConfirm();
            setIsRead(false);
        };
        return (
            <CustomModal
                className="DeregisterModal"
                footer={
                    <div className="deregister-modal-button-group">
                        <div
                            className="normal-button"
                            onClick={() => {
                                setIsRead(false);
                                setVisible && setVisible(false);
                            }}
                        >
                            {t("identificationVerify.cancel")}
                        </div>
                        <div
                            className="deregister-modal-button-item button-danger"
                            onClick={handleOnNext}
                        >
                            {t("nextStep")}
                        </div>
                    </div>
                }
                open={visible}
                renderHeader={t("deregisterAccount.title")}
                setVisible={setVisible}
                width={481}
                onClickClose={() => setIsRead(false)}
            >
                <div className="deregister-modal-warn-text">
                    {t("deregisterAccount.description")}
                </div>
                <div
                    dangerouslySetInnerHTML={{ __html: t("deregisterAccount.deregisterKnow") }}
                    className="deregister-rules-to-know"
                ></div>
                <div className="deregister-check-read">
                    <Checkbox
                        checked={isRead}
                        className="deregister-check-read-checkbox"
                        onChange={() => setIsRead(!isRead)}
                    />
                    <div className="deregister-check-read-text" onClick={() => setIsRead(!isRead)}>
                        <span>
                            {t("deregisterAccount.agreement")}
                            <a
                                className="deregister-check-link-text"
                                href={DEREGISTER_POLICY}
                                rel="noreferrer"
                                target="_blank"
                                onClick={e => e.stopPropagation()}
                            >
                                &nbsp;{t("deregisterAccount.deregisterToKnow")}
                            </a>
                        </span>
                    </div>
                </div>
            </CustomModal>
        );
    },
);
